import React from 'react'

const SeoHead = ({ seo }) => {
  return (
    <div>
      <title>{seo.metaTitle}</title>
      <link rel="canonical" href={window.location.href} />
      <meta name="description" content={seo.metaDescription || ''} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seo.metaTitle} />
      <meta property="og:description" content={seo.metaDescription || ''} />
    </div>
  )
}

export default SeoHead
